// 2026-09-27 falso-offline: sonda de conectividad compartida (fail-open).
//
// Causa raíz: el overlay global (OnlineGuard) verificaba la red contra
// `/api/health` y trataba `!res.ok` como "sin internet". Pero /api/health
// devuelve 503 honesto cuando el backend está degradado (Supabase/Tavily
// caídos), 503 sin servicio configurado y 429 con rate-limit — todo eso con
// el usuario perfectamente online. Resultado: backend degradado o sonda
// lenta (>6s → abort) = overlay "Sin conexión" falso que bloquea toda la app.
//
// Regla: cualquier respuesta HTTP (200, 429, 500, 503…) PRUEBA que hay ruta
// hasta el origen → online. Solo un fallo a nivel de red (fetch rechaza:
// DNS, TCP, timeout/abort, bloqueo total) sugiere sin-red. Ante la duda,
// NO se declara offline (fail-open visual).
//
// Sonda ligera: `/api/version` (JSON estático + rate-limit fail-open, sin
// runHealthChecks pesado) con `?t=` anti-caché. One-shot solo al dudar de
// la red (evento offline, overlay bloqueado, Reintentar) — nunca polling
// en el caso común, sin costo CPU extra (AGENTS.md § Free-tier CPU budget).

const PROBE_PATH = "/api/version";
const PROBE_TIMEOUT_MS = 6000;

/** Prueba si hay ruta de red hasta el origen. Fail-open: ante duda, true. */
export async function probeOnline(): Promise<boolean> {
  try {
    const ctrl = new AbortController();
    const timer = setTimeout(() => ctrl.abort(), PROBE_TIMEOUT_MS);
    try {
      // One-shot al dudar de la red, no polling cacheable: el dueño de
      // caché es la ruta y el `?t=` revienta caché (paridad OnlineGuard).
      await fetch(`${PROBE_PATH}?t=${Date.now()}`, {
        method: "GET",
        signal: ctrl.signal,
      });
      // Cualquier respuesta HTTP (incluso 429/500/503) prueba conectividad.
      return true;
    } finally {
      clearTimeout(timer);
    }
  } catch {
    return false;
  }
}
